import { observable, action } from "mobx";
import {  PATH_CONTROLLA_FERMO_PEGNO, PATH_CONTROLLA_FERMO_PEGNO_CERT } from "../config/presdoc-fe-config";


class FermoStore {

  constructor(root) {   
    this.service = root.service
    
    
  }

  @observable messaggio = '';
  @observable servizioAttivo = false;


 

  @action
  getPathControllaFermo(tipoPratica){
    switch (tipoPratica) {
      case 'MP':
        return PATH_CONTROLLA_FERMO_PEGNO;
      case 'CP':
        return PATH_CONTROLLA_FERMO_PEGNO_CERT;
      default:
        return PATH_CONTROLLA_FERMO_PEGNO;
      
    }
  }

 
  @action
  controllaFermo(tipoPratica){
    return new Promise((resolve, reject) => {
    this.verificaInviata= false;   
    const params = {}
    this.service.doAjax('POST', this.getPathControllaFermo(tipoPratica), params).then(response => {   
      if(response.success) {
        this.messaggio = response.result.messaggio;
        this.servizioAttivo = response.result.servizioAttivo;
        resolve("Promise Resolved");
        
      }
      else{
        reject("Promise Rejected");
        
      }
        
    });
  });
    
  }

 

 

}

export default FermoStore;